export default "__VITE_ASSET__d2PXH0zW__"